import script from "./utility-switching-council-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./utility-switching-council-panel.vue?vue&type=script&setup=true&lang=ts"

import "./utility-switching-council-panel.vue?vue&type=style&index=0&id=14111c1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14111c1a"]])

export default __exports__